import { AmaTableFigureImagesBlock } from "./AmaTableFigureImagesBlock";
import { AppointmentListBlock } from "./AppointmentListBlock";
import { DocumentListBlock } from "./DocumentListBlock";
import { ReferenceImagesBlock } from "./ReferenceImagesBlock";
import type { ChatBlockRenderer } from "./types";

/**
 * `kind` → component, mirroring the `chatbotLinks` handler registry: the
 * transport stays generic and each new entity kind is one entry here plus
 * one backend render tool.
 *
 * A kind with no entry is not an error — the caller renders the block's
 * markdown fallback, so an older bundle receiving a newer kind shows the
 * same content every other consumer (history, Slack) shows.
 */
export const DEFAULT_CHAT_BLOCK_RENDERERS: Readonly<
  Record<string, ChatBlockRenderer>
> = {
  ama_table_figure_images: AmaTableFigureImagesBlock,
  appointment_list: AppointmentListBlock,
  document_list: DocumentListBlock,
  reference_images: ReferenceImagesBlock,
};

export function resolveBlockRenderer(
  kind: string,
  renderers: Readonly<
    Record<string, ChatBlockRenderer>
  > = DEFAULT_CHAT_BLOCK_RENDERERS,
): ChatBlockRenderer | null {
  return renderers[kind] ?? null;
}
